export default {"src":"/_next/static/media/MetalWeight-silver.e9db8894.svg","height":28,"width":32};